import { Regex } from "../../constant/Regex"

const { REGEX_IS_DESKTOP } = Regex

export const getValueByDevice = (value1: string, value2?: string) =>
  REGEX_IS_DESKTOP ? value1 : value2 || ""
